import { CommonModule } from "@angular/common";
import {
  Component,
  effect,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  signal,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";
import { ICustomerOverview } from "@rfm/shared-interfaces";
import { MessageService, ToastMessageOptions } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import Stripe from "stripe";
import { ThirdpartyStripeCheckoutFormComponent } from "../../third-party/stripe/stripe-payment/stripe-payment.component";

@Component({
  selector: "app-latest-invoice-payment",
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule],
  templateUrl: "./latest-invoice-payment.component.html",
  styleUrls: ["./latest-invoice-payment.component.scss"],
})
export class LatestInvoicePaymentComponent implements OnInit, OnChanges {
  @Input()
  customer_overview = signal<ICustomerOverview | undefined>(undefined);

  @Output() paymentProcessed = new EventEmitter<boolean>(); // Output event for angle changes

  hasSubscriptions: boolean = false;
  ref: DynamicDialogRef | undefined;
  outstandingBalance = false;
  currentBalance = 0;

  constructor(
    private router: Router,
    private dialogService: DialogService,
    private messageService: MessageService
  ) {
    effect(() => {
      const newValue = this.customer_overview();
      this.currentBalance = this.customer_overview()?.balances?.data.reduce(
        (accumulator: any, current: any) =>
          accumulator + current.current_balance,
        0
      );
      this.outstandingBalance = this.currentBalance > 0;
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.customer_overview() &&
      this.customer_overview()?.subscriptions &&
      this.customer_overview()?.subscriptions?.data
    ) {
      this.hasSubscriptions = true;
    } else {
      this.hasSubscriptions = false;
    }
  }

  makePayment() {
    console.log("Dumping Overview", this.customer_overview());

    this.ref = this.dialogService.open(ThirdpartyStripeCheckoutFormComponent, {
      data: {
        uid: this.customer_overview()?.id,
      },
      width: "50vw",
      modal: true,
      focusOnShow: false,
      style: {
        "background-color": "#111827",
      },
      contentStyle: { overflow: "auto" },
      breakpoints: {
        "960px": "75vw",
        "640px": "90vw",
      },
    });

    this.ref.onClose.subscribe((data: Stripe.PaymentIntent) => {
      if (data) {
        this.paymentProcessed.emit(true);

        this.messageService.add({
          severity: "success",
          text: "Payment was successful. Thank you!",
          life: 3000,
        } as ToastMessageOptions);
      }
    });
  }

  latestInvoice() {
    this.router.navigateByUrl("/billing/invoices");
  }

  ngOnInit() {}
}
